import type { PopupCampaign, PopupTriggerType } from "@/services/popupService";

export interface ActiveEnrollmentState {
  /** 'entry' | 'community' | 'course' (string to stay decoupled from ChallengeType). */
  challengeType: string;
  /** Result of calculateCurrentDay for this enrollment. */
  currentDay: number;
  /** challenge.total_days. */
  totalDays: number;
}

export interface UserPopupState {
  enrollments: ActiveEnrollmentState[];
}

export function matchesTrigger(trigger: PopupTriggerType, state: UserPopupState): boolean {
  switch (trigger) {
    case "everyone":
      return true;
    case "community_all":
      return state.enrollments.some((e) => e.challengeType === "community");
    case "entry_challenge_first_day":
      return state.enrollments.some((e) => e.challengeType === "entry" && e.currentDay === 1);
    case "entry_challenge_last_day":
      return state.enrollments.some(
        (e) => e.challengeType === "entry" && e.totalDays > 0 && e.currentDay === e.totalDays,
      );
    default:
      return false;
  }
}

/** Campaigns arrive priority-ordered from the RPC; return the first whose trigger matches. */
export function pickPopup(campaigns: PopupCampaign[], state: UserPopupState): PopupCampaign | null {
  return campaigns.find((c) => matchesTrigger(c.trigger_type, state)) ?? null;
}
